import React from 'react';
import { useHistory } from 'react-router-dom';

import { TableCell } from '@material-ui/core';
import { useStyles } from '../styles';

interface CellWithActionProps {
    id: string;
    content: any;
}

export const CellWithAction = (props: CellWithActionProps) => {
    const classes = useStyles();
    const history = useHistory();

    return (
        <TableCell
            className={classes.cell}
            align="left"
            onClick={() => history.push(`/restaurants/${props.id}`)}
        >
            {props.content}
        </TableCell>
    );
};
